import { Plan } from 'components/plan';
const PlanContainer = Plan;
export { PlanContainer };
